module.exports = __webpack_public_path__ + "img/arrow_head_left_p.79154fb6.svg";